(function() {
  if (customElements.get('gallery-look-modal')) return;

  var GalleryLookModal = class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.dialog = this.querySelector('[role="dialog"]');
      this.panes = Array.from(this.querySelectorAll('[data-look-pane]'));
      this.index = 0;
      this.pointer = { x: 0, y: 0, tracking: false, dragged: false };
      this.previouslyFocused = null;

      this.onSectionClick = this.onSectionClick.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.section.addEventListener('click', this.onSectionClick);
      this.section.addEventListener('pointerdown', this.onPointerDown);
      this.section.addEventListener('pointermove', this.onPointerMove);
      this.section.addEventListener('pointerup', this.onPointerUp);
      this.section.addEventListener('pointercancel', this.onPointerUp);
      this.addEventListener('click', this.onModalClick);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.querySelectorAll('.gallery-look__photo').forEach(function(photo) {
        var image = photo.querySelector('.gallery-look__photo-image');
        if (!image) return;
        var ready = function() { photo.classList.add('is-ready'); };
        if (image.complete && image.naturalWidth) ready();
        else image.addEventListener('load', ready, { once: true });
      });

      this.onProductsClick = this.onProductsClick.bind(this);
      this.onProductsScroll = this.onProductsScroll.bind(this);
      this.addEventListener('click', this.onProductsClick);
      this.querySelectorAll('[data-look-products-scroller]').forEach(function(scroller) {
        scroller.addEventListener('scroll', this.onProductsScroll, { passive: true });
      }, this);
      this.updateProductArrows();
    }

    disconnectedCallback() {
      this.section.removeEventListener('click', this.onSectionClick);
      this.section.removeEventListener('pointerdown', this.onPointerDown);
      this.section.removeEventListener('pointermove', this.onPointerMove);
      this.section.removeEventListener('pointerup', this.onPointerUp);
      this.section.removeEventListener('pointercancel', this.onPointerUp);
      this.removeEventListener('click', this.onModalClick);
      this.removeEventListener('click', this.onProductsClick);
      this.querySelectorAll('[data-look-products-scroller]').forEach(function(scroller) {
        scroller.removeEventListener('scroll', this.onProductsScroll);
      }, this);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.documentElement.classList.remove('gallery-look-open');
    }

    onPointerDown(event) {
      if (!event.target.closest('.gallery__media')) return;
      this.pointer.x = event.clientX;
      this.pointer.y = event.clientY;
      this.pointer.tracking = true;
      this.pointer.dragged = false;
    }

    onPointerMove(event) {
      if (!this.pointer.tracking) return;
      if (Math.abs(event.clientX - this.pointer.x) > 8 || Math.abs(event.clientY - this.pointer.y) > 8) {
        this.pointer.dragged = true;
      }
    }

    onPointerUp() {
      this.pointer.tracking = false;
      var modal = this;
      setTimeout(function() {
        modal.pointer.dragged = false;
      }, 0);
    }

    onSectionClick(event) {
      var trigger = event.target.closest('[data-gallery-look-open]');
      var imageLink = event.target.closest('[data-gallery-image-link]');
      if (this.pointer.dragged && (trigger || imageLink)) {
        event.preventDefault();
        this.pointer.dragged = false;
        return;
      }
      if (!trigger || !this.section.contains(trigger)) return;
      event.preventDefault();
      this.open(Number(trigger.getAttribute('data-gallery-look-open')));
    }

    onModalClick(event) {
      if (event.target.closest('[data-gallery-look-close]')) {
        this.close();
        return;
      }
      if (event.target.closest('[data-gallery-look-prev]')) this.step(-1);
      if (event.target.closest('[data-gallery-look-next]')) this.step(1);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        if (event.target.closest('.gallery-look__products, .gallery-look__color-list, .gallery-look__fabric-list')) return;
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1);
        return;
      }
      if (event.key === 'Tab') this.trapFocus(event);
    }

    onBlockSelect(event) {
      if (!this.section.contains(event.target)) return;
      var trigger = event.target.querySelector('[data-gallery-look-open]');
      if (!trigger) return;
      this.open(Number(trigger.getAttribute('data-gallery-look-open')));
    }

    open(index) {
      if (!this.panes.length) return;
      this.hidden = false;
      this.setIndex(index);
      document.documentElement.classList.add('gallery-look-open');
      this.previouslyFocused = document.activeElement;
      document.addEventListener('keydown', this.onKeydown);
      this.updateProductArrows();
      var closeButton = this.querySelector('[data-gallery-look-close].gallery-look__close');
      if (closeButton) closeButton.focus();
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      document.documentElement.classList.remove('gallery-look-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
        this.previouslyFocused.focus();
      }
    }

    step(direction) {
      if (this.panes.length < 2) return;
      this.setIndex(this.index + direction);
    }

    setIndex(index) {
      var count = this.panes.length;
      this.index = (index + count) % count;
      this.panes.forEach(function(pane, paneIndex) {
        var image = pane.querySelector('img');
        if (image && (paneIndex === this.index || paneIndex === (this.index + 1) % count)) {
          image.loading = 'eager';
        }
        pane.hidden = paneIndex !== this.index;
      }, this);
      this.updateProductArrows();
    }

    onProductsClick(event) {
      var button = event.target.closest('[data-look-products-prev], [data-look-products-next]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      var wrap = button.closest('[data-look-products]');
      var scroller = wrap && wrap.querySelector('[data-look-products-scroller]');
      if (!scroller) return;
      var card = scroller.querySelector('.gallery-look__product');
      var distance = card ? card.getBoundingClientRect().width + 12 : Math.round(scroller.clientWidth * 0.8);
      var direction = button.hasAttribute('data-look-products-next') ? 1 : -1;
      scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    onProductsScroll(event) {
      this.updateProductArrows(event.currentTarget.closest('[data-look-products]'));
    }

    updateProductArrows(wrap) {
      var wraps = wrap ? [wrap] : Array.from(this.querySelectorAll('[data-look-products]'));
      wraps.forEach(function(item) {
        if (!item) return;
        var scroller = item.querySelector('[data-look-products-scroller]');
        var prev = item.querySelector('[data-look-products-prev]');
        var next = item.querySelector('[data-look-products-next]');
        if (!scroller || !prev || !next) return;
        var count = scroller.querySelectorAll('.gallery-look__product').length;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var canPrev = scroller.scrollLeft > 4;
        var canNext = count >= 4 && maxScroll > 4 && scroller.scrollLeft < maxScroll - 4;
        prev.classList.toggle('is-active', canPrev);
        next.classList.toggle('is-active', canNext);
        var media = scroller.querySelector('.gallery-look__product-media');
        if (media && media.offsetHeight) {
          var top = media.offsetTop + (media.offsetHeight - 40) / 2;
          prev.style.top = top + 'px';
          next.style.top = top + 'px';
        }
      });
    }

    trapFocus(event) {
      var nodes = this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(nodes, function(node) {
        return node.offsetParent !== null;
      });
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  customElements.define('gallery-look-modal', GalleryLookModal);
})();
